module.exports = __webpack_public_path__ + "static/media/notes-off.e1408b57.svg";